<div class="tutorial-item-arquivo row g-0">
  <div class="col-12">
    <button (click)="voltar()" class="btn return-button">
      <span class="font-icon">undo</span> Voltar
    </button>
  </div>
  <iframe *ngIf="type == 'link'" [src]="link" title="YouTube video player"  frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  <img class="image-item"  *ngIf="type == 'image/png' && file" [src]="file" alt="Imagem">
  <iframe [src]="file" *ngIf="type == 'application/pdf' && file" width="100%" height="600px"></iframe>

  <div class="col-12" *ngIf="type != 'link' && type != 'application/pdf'">
    <button (click)="download()" class="btn btn-blue-2 mt-2">
      <span class="font-icon ">download</span> Baixar arquivo
    </button>
  </div>

</div>
<app-loading [loader]="isLoading"></app-loading>